import { render, staticRenderFns } from "./FollowUpDialog.vue?vue&type=template&id=09a4d146&scoped=true"
import script from "./FollowUpDialog.vue?vue&type=script&lang=js"
export * from "./FollowUpDialog.vue?vue&type=script&lang=js"
import style0 from "./FollowUpDialog.vue?vue&type=style&index=0&id=09a4d146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a4d146",
  null
  
)

export default component.exports